import React, { useState, useEffect } from "react";
import * as helper                    from "../global/Helper";
import "./KnowledgeBaseCategory.css";


const  KnowledgeBaseTable = (props) => {
  
  const {
    editKnowledgeBaseHandler,
    toggleKnowledgeBaseStatus
  } = props;

  const [allKnowledgeBases, setAllKnowledgeBases] = useState(props.allKnowledgeBases);
  const [showRemoveSearch, setshowRemoveSearch] = useState(false);

  const searchBaseHandler = ({target}) => {
    if (target.value === "") {
      setshowRemoveSearch(false);
      return setAllKnowledgeBases(props.allKnowledgeBases);
    }

    setshowRemoveSearch(true);
    const matchedBase = props.allKnowledgeBases.filter((t)=>{

      let matchBase = `${t.Title} ${t.CategoryName}`;
      let matchFound = 0;

      const searchArr = target.value.split(' ');
      searchArr.forEach(element => {
        matchFound += matchBase.toLowerCase().includes(element.toLowerCase()) ? 1: 0;
      });
      return matchFound === searchArr.length;
    })
    setAllKnowledgeBases(matchedBase);
  }

  const clearSearchHandler = () =>{ 
    $("#generalSearch").val("");
    setshowRemoveSearch(false);
    return setAllKnowledgeBases(props.allKnowledgeBases);
  }

  useEffect(() => {
    helper.SetScrollHeight();
  });

  return (
    <div className="kt-form kt-form--label-right kt-margin-b-10">
      <div className="row align-items-center stickyFilter">
        <div className="col-xl-12 order-2 order-xl-1">
          <div className="row align-items-center">
            <div className="col-md-4 kt-margin-b-20-tablet-and-mobile margin-b0">
              <div className="kt-input-icon kt-input-icon--left">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search KnowledgeBase..."
                  id="generalSearch"
                  onChange={searchBaseHandler}>
                </input>
                <span className="kt-input-icon__icon kt-input-icon__icon--left">
                  <span>
                    <i className="la la-search"></i>
                  </span>
                </span>
                {showRemoveSearch && (
                  <span className="kt-input-icon__icon kt-input-icon__icon--right">
                      <span onClick={clearSearchHandler}>
                          <i className="la la-close"></i>
                      </span>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {allKnowledgeBases.length > 0 ? (
        <div className="row">
          <div className="col-sm-12">
            <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--scroll kt-datatable--loaded margin-b0">
              <table className="kt-datatable__table">
                <thead
                  className="kt-datatable__head"
                  style={{ display: "block" }}>
                  <tr className="kt-datatable__row block-row">
                    <th className="kt-datatable__cell text-clip" width="80%">
                      <span>KnowledgeBase</span>
                    </th>
                    <th className="kt-datatable__cell--right kt-datatable__cell padding-l50" width="20%">
                      <span className="margin-r40">Action</span>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div
              className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--scroll kt-datatable--loaded scrolTable"
              onScroll={helper.setStickyHeader}>
              <table className="kt-datatable__table table-striped">
                <tbody
                  className="kt-datatable__body"
                  style={{ display: "block" }}>
                  {allKnowledgeBases.map((t, i) => {
                    return (
                      <tr
                        key={i}
                        className="kt-datatable__row block-row clickable">
                        <td
                          width="80%"
                          title={t.Title}
                          className="kt-datatable__cell text-clip">
                          <div className="kt-user-card-v2">
                            <div className="kt-user-card-v2__pic mr-2">
                            {t.Image ? <img src={t.Image} alt={t.Title} />
                            :<div className="kt-badge kt-badge--xl kt-badge--success">
                                {t.Title.slice(0, 1)}
                              </div>
                            }
                            </div>
                            <div className="kt-user-card-v2__details text-clip">
                              <span className="kt-user-card-v2__name text-clip">
                                {t.Title}
                              </span>
                              {t.CategoryName && (
                                <span 
                                  title={t.CategoryName}
                                  className ="kt-user-card-v2__desc text-clip">
                                  {t.CategoryName.toLowerCase()}
                                </span>
                              )}
                            </div>
                          </div>
                        </td>
                        <td
                          className="kt-datatable__cell lucid"
                          width="20%">
                          <button
                            type="button"
                            className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10"
                            onClick={()=>editKnowledgeBaseHandler(t,i)}>
                            <i className="flaticon2-edit"></i>  
                          </button>
                          <span className="kt-switch kt-switch--icon padding-l10 padding-t5 ">
                            <label>
                              <input
                                type="checkbox"
                                name=""
                                defaultChecked={
                                  t.Active === "Y" ? "checked" : ""
                                }
                                onChange={()=>toggleKnowledgeBaseStatus(t)}
                              />
                              <span></span>
                            </label>
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <span className="empty-table-message">No Knowledge Base Found</span>
      )}
    </div>
  );
};

export default KnowledgeBaseTable;
